<template>
<div id="home">
  <my-header></my-header>
    <div class="image-store" v-if="store && store.banner_image" v-bind:style="{ backgroundImage: 'url(' + store.banner_image.thumb_path + ')' }" >
    </div>
  <div class="pd20 pdt0">
    <loading v-if="loading" :text="'Please wait'|translate"></loading>

    <div v-if="store">

      <div class="row " v-if="!loading" >
        <div class="col-md-6 ">

          <h3>{{store.name}}</h3>
              <!--
          <p>
            <router-link  :to="{ name: 'Profile',params: { profileId: store.user_unique_code }}"><i class="fas fa-user-tie"></i> {{'Owner Profile'|translate}}</router-link>
          </p>
          <p>
            <router-link :to="{ name: 'SaleMarketStore', params: { store_id: store.id }}"><i class="fas fa-store-alt"></i> {{'Sale Market'|translate}}</router-link> &nbsp;&nbsp;
          </p>

      <favorite-control :storeId="store.id"></favorite-control>
           -->
          <p v-if="!store.name">{{'No information'|translate}}</p>
          <label class="mt10">Điện thoại:</label>
          <p v-for="phone in store.phones" v-bind:key="phone" >

              <a :href="'tel:'+phone">
            <i class="fas fa-phone"></i> {{phone}}
              </a>
            </p>
          <p v-if="!store.phone">{{'No information'|translate}}</p>
          <div v-if="store.full_address">
            <label class="mt10">{{'Address'|translate}}:</label>
            <p>{{ store.full_address }}</p>
          </div>

          <label class="mt10">Facebook:</label>
          <p v-if="store.facebook"><a :href="store.facebook">{{store.facebook}}</a></p>
          <p v-if="!store.facebook">{{'No information'|translate}}</p>

        </div>
        <!-- end col-md-6 -->
        <div class="col-md-6 mt10">
          <label>{{'Products available in store'|translate}}:</label>
          <p v-if="store.products.length==0">{{'No product'|translate}}</p>
          <div class="list-tags">
            <router-link class="mytag selected" v-for="(varriant) in store.products" :key="varriant.id" :to="{ name: 'SaleMarketStoreWithVarriant', params: { store_id: store.id,product_id:varriant.product_id,varriant_id:varriant.id   }}">{{varriant.name}}</router-link>

          </div>

          <p class="mt10 mb0"><label>Mã QR:</label></p>

        <qrcode :value="getLink()" tag="img" :options="{ width: size }"></qrcode>
        <p><small>Bạn có thể dùng mã code này để chia sẻ link</small</p>
          <div v-if="store.store_location">
            <label class="mt10">Vị trí vườn:</label>
            <p><a target="_blank" :href="'https://www.google.com/maps?q='+store.store_location[0]+','+store.store_location[1]">{{store.store_address}}</a></p>
            <div id="map"></div>
          </div>

        </div>
        <!-- end col-md-6 -->
      </div>
    </div>

  </div>
  <!-- end pd20 -->
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'
import FavoriteControl from '@/components/elements/FavoriteControl'
export default {
  name: 'store',
  components: {
    MyHeader,
    Loading,
    FavoriteControl
  },
  data () {
    return {
      loading: true,
      store: null,
      value: 'https://example.com',
      size: 120
    }
  },
  watch: {
    $route (to, from) {
      this.loadInfo()
    }
  },
  methods: {
    getLink () {
      return window.location.href
    },
    loadInfo () {
      this.loading = true
      this.store = null
      let storeId = this.$route.params.storeId

      let wating = [Utils.getAllProducts(this, {})]

      wating.push(Utils.requestV2(this, true).get(
        `/stores/${storeId}`
      ))

      Promise.all(wating).then(values => {
        this.all_products = values[0]
        let store = values[1].data
        store.phones = store.phone ? store.phone.split(',') : []
        this.store = store
        console.log('this.store', this.store)
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/ProfileStore.vue